/**
 * @enum GamingAggregatorIdEnum
 * @description Defines unique identifier constants for gaming aggregators in the system.
 * Each constant represents a different gaming content provider/aggregator with their assigned ID.
 */
export enum GamingAggregatorIdEnum {
  /** @constant {bigint} Starsoft - Starsoft gaming aggregator (ID: 1) */
  Starsoft = 1,

  /** @constant {bigint} Softswiss - Softswiss gaming aggregator (ID: 2) */
  Softswiss = 2,

  /** @constant {bigint} PGSoft - PG Soft gaming provider (ID: 3) */
  PGSoft = 3,

  /** @constant {bigint} Spribe - Spribe gaming provider (ID: 4) */
  Spribe = 4,

  /** @constant {bigint} PragmaticPlay - Pragmatic Play gaming provider (ID: 5) */
  PragmaticPlay = 5,

  /** @constant {bigint} Evolution - Evolution Gaming provider (ID: 6) */
  Evolution = 6,

  /** @constant {bigint} Playtech - Playtech gaming provider (ID: 7) */
  Playtech = 7,

  /** @constant {bigint} Betby - Betby gaming provider (ID: 8) */
  Betby = 8,

  /** @constant {bigint} First - First gaming provider (ID: 9) */
  First = 9,
}

/**
 * @description Type representing any valid gaming aggregator ID value
 * @example const aggregatorId: GamingAggregatorIdTypeEnum = GamingAggregatorIdEnum.Starsoft;
 */
